import React, {useEffect, useRef, useState} from 'react';

// 이미지 임포트 (실제 이미지 경로로 변경 필요)
import inf01 from '../../../assets/images/about/section_02_subsection_03_item_01.png';
import inf02 from '../../../assets/images/about/section_02_subsection_03_item_02.png';
import inf03 from '../../../assets/images/about/section_02_subsection_03_item_03.png';
import inf04 from '../../../assets/images/about/section_02_subsection_03_item_04.png';
import inf05 from '../../../assets/images/about/section_02_subsection_03_item_05.png';
import inf06 from '../../../assets/images/about/section_02_subsection_03_item_06.png';
import inf07 from '../../../assets/images/about/section_02_subsection_03_item_07.png';
import inf08 from '../../../assets/images/about/section_02_subsection_03_item_08.png';
import store01 from "@/assets/images/about/section_02_subsection_02_item_01.png";
import store02 from "@/assets/images/about/section_02_subsection_02_item_02.png";

const AboutSubSection0203: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // 섹션이 화면에 보일 때만 애니메이션 적용
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          // 섹션이 화면에서 벗어났을 때
          setIsVisible(false);
        }
      },
      {
        threshold: window.innerWidth <= 1024 ? 0.08 : 0.2, // 섹션이 20% 이상 보일 때 트리거 // 섹션이 20% 이상 보일 때 트리거
        rootMargin: '-50px' // 뷰포트 경계에서 50px 안쪽에서 트리거
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div ref={sectionRef} className={`container text-black py-[76px] transition-all duration-[1500ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className="hidden lg:block mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 이미지, 오른쪽 텍스트 */}
        <div className="flex flex-row items-center justify-between lg:gap-8 xl:gap-16 2xl:gap-32">

          {/* 오른쪽: 텍스트 정보 */}
          <div className="w-1/2 2xl:w-2/5">
            {/* 섹션 제목 */}
            <p className="text-xl font-semibold mb-[72px]">
              Influencer Marketing
            </p>
            <p className="text-40 leading-[1.4] font-bold mb-[72px]">
              콘텐츠로 연결되는 실매출<br/>
              국내외 인플루언서 공동 기획
            </p>
            <p className="text-xl font-normal leading-[1.6] mb-[55px]">
              국내외 인플루언서와 함께 제품을 기획하고 공동구매 형태로 실판매까지 직접 전개합니다.<br/>
              기획 → 콘텐츠 → 공동구매까지 하나로 연결된 원스톱 구조로 실질 매출을 만들어냅니다.
            </p>
          </div>


          {/* 오른쪽: 이미지 */}
          <div className="w-1/2 2xl:w-2/5">
            <div className="grid grid-cols-4 gap-2  max-w-[728px]">
              {/* 각 이미지 아이템 */}
              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf01})`}}>
                <p className="text-black text-54 font-bold">
                  688<span className="text-34">k</span>
                </p>
              </div>

              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf02})`}}>
                <p className="text-black text-54 font-bold">
                  491<span className="text-34">k</span>
                </p>
              </div>

              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf03})`}}>
                <p className="text-black text-54 font-bold">
                  417<span className="text-34">k</span>
                </p>
              </div>

              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf04})`}}>
                <p className="text-black text-54 font-bold">
                  230<span className="text-34">k</span>
                </p>
              </div>

              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf05})`}}>
                <p className="text-black text-54 font-bold">
                  194<span className="text-34">k</span>
                </p>
              </div>

              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf06})`}}>
                <p className="text-black text-54 font-bold">
                  137<span className="text-34">k</span>
                </p>
              </div>

              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf07})`}}>
                <p className="text-black text-54 font-bold">
                  100<span className="text-34">k</span>
                </p>
              </div>

              <div className="aspect-[172/266] bg-cover bg-center flex items-center justify-center"
                   style={{backgroundImage: `url(${inf08})`}}>
                <p className="text-black text-54 font-bold">
                  77<span className="text-34">k</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:hidden mx-auto">
        {/* 메인 콘텐츠 - 왼쪽 텍스트, 오른쪽 이미지 */}
        <div className="flex flex-col items-center justify-center">
          {/* 왼쪽: 통계 정보 */}
          <p className="text-2xl md:text-4xl font-semibold mb-[30px] md:mb-[50px]">
            Influencer Marketing
          </p>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold md:mb-4">
              콘텐츠로 연결되는 실매출
          </span>
          <span className="text-4xl md:text-6xl leading-[1.4] font-bold">
              국내외 인플루언서 공동 기획
          </span>

          <div className="grid grid-cols-4 gap-2 py-20 md:py-28">
            {/* 각 이미지 아이템 */}
            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf01})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                688<span className="text-34">k</span>
              </p>
            </div>

            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf02})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                491<span className="text-34">k</span>
              </p>
            </div>

            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf03})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                417<span className="text-34">k</span>
              </p>
            </div>

            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf04})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                230<span className="text-34">k</span>
              </p>
            </div>

            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf05})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                194<span className="text-34">k</span>
              </p>
            </div>

            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf06})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                137<span className="text-34">k</span>
              </p>
            </div>

            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf07})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                100<span className="text-34">k</span>
              </p>
            </div>

            <div className="aspect-[172/266] bg-cover bg-center flex px-2 md:px-8 items-center justify-center"
                 style={{backgroundImage: `url(${inf08})`}}>
              <p className="text-black text-4xl md:text-5xl md:text-54 font-bold">
                77<span className="text-34">k</span>
              </p>
            </div>
          </div>

          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            국내외 인플루언서와 함께 제품을 기획하고</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            공동구매 형태로 실판매까지 직접 전개합니다.</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            기획 → 콘텐츠 → 공동구매까지 하나로 연결된</p>
          <p className="text-center font-normal text-2xl md:text-4xl leading-[1.6] md:mb-2">
            원스톱 구조로 실질 매출을 만들어냅니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSubSection0203;